import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'card-item',

  imports: [MatIcon],
  templateUrl: './card-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card-item.component.scss',
})
export class CardItemComponent {
  @Input() icon: string;
}
